import { render, staticRenderFns } from "./TV.vue?vue&type=template&id=7b205475"
import script from "./TV.vue?vue&type=script&lang=ts"
export * from "./TV.vue?vue&type=script&lang=ts"
import style0 from "./TV.vue?vue&type=style&index=0&id=7b205475&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports